module.exports = __webpack_public_path__ + "img/health_wellbeing.3ab59a22.jpg";